export interface MarketplaceListing {
  id: string;
  slug: string;
  title: string;
  price: number;
  priceDisplay: string;
  description: string;
  category: string;
  status: 'Available' | 'Pending' | 'Sold';
  sellerName: string;
  sellerSlug: string;
  sellerRole: string;
  sellerTower: string;
  sellerUnit: string;
  images: string[];
  tags: string[];
  date: string;
  condition?: string;
}

export const mockListings: MarketplaceListing[] = [
  {
    id: 'ml1',
    slug: 'west-elm-sofa-gray',
    title: 'West Elm Harmony Sofa — Platinum Gray',
    price: 1200,
    priceDisplay: '$1,200',
    description: 'West Elm Harmony 3-seat sofa in platinum gray performance velvet. Purchased new in 2023, excellent condition. Moving to a smaller unit and it won\'t fit. Dimensions: 88"W x 37"D x 33"H. No pets, no smoking unit.',
    category: 'Furniture',
    status: 'Available',
    sellerName: 'Claire Fontaine',
    sellerSlug: 'claire-fontaine',
    sellerRole: 'Owner',
    sellerTower: 'Tower 2',
    sellerUnit: '2901',
    images: [],
    tags: ['West Elm', 'Sofa', 'Gray', 'Performance Velvet', 'Like New'],
    date: 'March 18, 2026',
    condition: 'Like New',
  },
  {
    id: 'ml2',
    slug: 'peloton-bike-plus',
    title: 'Peloton Bike+ with Accessories',
    price: 1800,
    priceDisplay: '$1,800',
    description: 'Peloton Bike+ in excellent condition. Includes original mat, weights (3lb and 5lb), cycling shoes (size 10M), and 3 months of remaining subscription. Purchased 2022, lightly used. Buyer responsible for moving within building.',
    category: 'Fitness Equipment',
    status: 'Pending',
    sellerName: 'Natasha Volkov',
    sellerSlug: 'natasha-volkov',
    sellerRole: 'Owner',
    sellerTower: 'Tower 2',
    sellerUnit: '3305',
    images: [],
    tags: ['Peloton', 'Fitness', 'Bike', 'Accessories Included'],
    date: 'March 16, 2026',
    condition: 'Excellent',
  },
  {
    id: 'ml3',
    slug: 'standing-desk-flexispot',
    title: 'FlexiSpot E7 Pro Standing Desk — White',
    price: 450,
    priceDisplay: '$450',
    description: 'FlexiSpot E7 Pro electric standing desk, white frame with 60"x24" white tabletop. Works perfectly, selling because I\'m switching to a built-in desk. Includes cable management tray. Disassembled for easy transport.',
    category: 'Office',
    status: 'Available',
    sellerName: 'Ryan Kowalski',
    sellerSlug: 'ryan-kowalski',
    sellerRole: 'Renter',
    sellerTower: 'Tower 1',
    sellerUnit: '1203',
    images: [],
    tags: ['Standing Desk', 'Office', 'Electric', 'White'],
    date: 'March 15, 2026',
    condition: 'Good',
  },
  {
    id: 'ml4',
    slug: 'baby-bassinet-snoo',
    title: 'SNOO Smart Bassinet by Happiest Baby',
    price: 900,
    priceDisplay: '$900',
    description: 'SNOO Smart Bassinet in excellent condition. Used for 5 months. Includes all original accessories, swaddles, and power adapter. Retail $1,695. Baby outgrew it — it\'s in perfect working order.',
    category: 'Baby Items',
    status: 'Available',
    sellerName: 'Amanda Park',
    sellerSlug: 'amanda-park',
    sellerRole: 'Renter',
    sellerTower: 'Tower 2',
    sellerUnit: '1102',
    images: [],
    tags: ['SNOO', 'Baby', 'Bassinet', 'Smart', 'Excellent Condition'],
    date: 'March 14, 2026',
    condition: 'Excellent',
  },
  {
    id: 'ml5',
    slug: 'lg-oled-65-tv',
    title: 'LG C2 65" OLED TV',
    price: 1100,
    priceDisplay: '$1,100',
    description: 'LG C2 65" OLED evo TV. Purchased December 2022. Excellent picture quality, no burn-in. Selling because I upgraded to a larger screen. Includes original remote, stand, and all cables. Wall mount not included.',
    category: 'Electronics',
    status: 'Sold',
    sellerName: 'Marcus Chen',
    sellerSlug: 'marcus-chen',
    sellerRole: 'Owner',
    sellerTower: 'Tower 1',
    sellerUnit: '2204',
    images: [],
    tags: ['LG', 'OLED', '65 inch', 'TV', '4K'],
    date: 'March 10, 2026',
    condition: 'Excellent',
  },
  {
    id: 'ml6',
    slug: 'abstract-art-canvas',
    title: 'Large Abstract Canvas — 48"x60"',
    price: 380,
    priceDisplay: '$380',
    description: 'Original abstract canvas painting, 48"x60". Deep blues, violets, and gold tones — works beautifully in modern high-rise interiors. Purchased from a local Las Vegas gallery in 2021. Comes with hanging hardware.',
    category: 'Home Decor',
    status: 'Available',
    sellerName: 'Priya Nair',
    sellerSlug: 'priya-nair',
    sellerRole: 'Owner',
    sellerTower: 'Tower 1',
    sellerUnit: '1807',
    images: [],
    tags: ['Art', 'Canvas', 'Abstract', 'Large Format', 'Original'],
    date: 'March 12, 2026',
    condition: 'Excellent',
  },
  {
    id: 'ml7',
    slug: 'sphere-concert-tickets',
    title: '2x Sphere Las Vegas Tickets — April 19',
    price: 320,
    priceDisplay: '$320 for both',
    description: 'Two tickets to a show at the Sphere on April 19. Section 201, Row 12. Can\'t attend due to travel. Face value was $280 total. Prefer to sell to a neighbor — easy handoff in the building.',
    category: 'Tickets / Misc',
    status: 'Available',
    sellerName: 'James Whitfield',
    sellerSlug: 'james-whitfield',
    sellerRole: 'Multiple Unit Owner',
    sellerTower: 'Tower 1',
    sellerUnit: '3101',
    images: [],
    tags: ['Sphere', 'Tickets', 'Concert', 'April', 'Las Vegas'],
    date: 'March 17, 2026',
    condition: 'N/A',
  },
  {
    id: 'ml8',
    slug: 'yoga-mat-manduka',
    title: 'Manduka PRO Yoga Mat — Black',
    price: 85,
    priceDisplay: '$85',
    description: 'Manduka PRO yoga mat in black, 71" length. Used about 10 times — I switched to a different mat. In excellent condition, no wear. Retail $140. Includes carrying strap.',
    category: 'Fitness Equipment',
    status: 'Available',
    sellerName: 'Sofia Reyes',
    sellerSlug: 'sofia-reyes',
    sellerRole: 'Renter',
    sellerTower: 'Tower 2',
    sellerUnit: '1504',
    images: [],
    tags: ['Yoga', 'Manduka', 'Mat', 'Fitness'],
    date: 'March 13, 2026',
    condition: 'Like New',
  },
  {
    id: 'ml9',
    slug: 'storage-unit-available-b12',
    title: 'Storage Unit Available — B-12',
    price: 120,
    priceDisplay: '$120/mo',
    description: 'Resident storage unit B-12 available for sublease. Located on the lower level, approximately 5\'x8\'. Climate-controlled building storage. Clean and dry. Ideal for seasonal items, luggage, or overflow from your unit. Month-to-month arrangement with 30-day notice.',
    category: 'Storage',
    status: 'Available',
    sellerName: 'James Whitfield',
    sellerSlug: 'james-whitfield',
    sellerRole: 'Multiple Unit Owner',
    sellerTower: 'Tower 1',
    sellerUnit: '3101',
    images: [],
    tags: ['Storage', 'Monthly', 'Lower Level', 'Climate Controlled'],
    date: 'March 19, 2026',
    condition: 'N/A',
  },
  {
    id: 'ml10',
    slug: 'parking-space-tower2-p44',
    title: 'Parking Space — Tower 2, P-44',
    price: 175,
    priceDisplay: '$175/mo',
    description: 'Assigned parking space P-44 in the Tower 2 garage available for monthly lease. Covered, ground-level, easy access to elevator. Ideal for a second vehicle or a resident who needs additional parking. 30-day notice to vacate.',
    category: 'Parking',
    status: 'Available',
    sellerName: 'Claire Fontaine',
    sellerSlug: 'claire-fontaine',
    sellerRole: 'Owner',
    sellerTower: 'Tower 2',
    sellerUnit: '2901',
    images: [],
    tags: ['Parking', 'Monthly', 'Covered', 'Tower 2', 'Ground Level'],
    date: 'March 20, 2026',
    condition: 'N/A',
  },
  {
    id: 'ml11',
    slug: 'looking-for-parking-tower1',
    title: 'Looking for Parking — Tower 1',
    price: 0,
    priceDisplay: 'Negotiable',
    description: 'Looking for a monthly parking space in or near Tower 1. Have one assigned space but need a second for a visiting family member who stays regularly. Happy to pay fair market rate. Please reach out if you have a space available.',
    category: 'Wanted',
    status: 'Available',
    sellerName: 'Ryan Kowalski',
    sellerSlug: 'ryan-kowalski',
    sellerRole: 'Renter',
    sellerTower: 'Tower 1',
    sellerUnit: '1203',
    images: [],
    tags: ['Wanted', 'Parking', 'Tower 1', 'Monthly'],
    date: 'March 18, 2026',
    condition: 'N/A',
  },
  {
    id: 'ml12',
    slug: 'trek-fx3-bicycle',
    title: 'Trek FX 3 Disc Bicycle — Medium',
    price: 650,
    priceDisplay: '$650',
    description: 'Trek FX 3 Disc fitness hybrid bike, medium frame, matte black. Purchased 2023, ridden lightly. Hydraulic disc brakes, 24-speed drivetrain. Excellent condition. Includes front and rear lights, lock, and pump. Stored in the building bike room.',
    category: 'Bicycles',
    status: 'Available',
    sellerName: 'Marcus Chen',
    sellerSlug: 'marcus-chen',
    sellerRole: 'Owner',
    sellerTower: 'Tower 1',
    sellerUnit: '2204',
    images: [],
    tags: ['Bicycle', 'Trek', 'Hybrid', 'Fitness', 'Disc Brakes'],
    date: 'March 17, 2026',
    condition: 'Excellent',
  },
  {
    id: 'ml13',
    slug: 'wanted-extra-storage-unit',
    title: 'Wanted: Extra Storage Unit',
    price: 0,
    priceDisplay: 'Up to $150/mo',
    description: 'Looking for a resident storage unit to sublease. Moving in next month and have more items than my unit can hold. Will pay up to $150/month for a clean, dry storage space. Any tower, any level. Please reach out if you have something available.',
    category: 'Wanted',
    status: 'Available',
    sellerName: 'Amanda Park',
    sellerSlug: 'amanda-park',
    sellerRole: 'Renter',
    sellerTower: 'Tower 2',
    sellerUnit: '1102',
    images: [],
    tags: ['Wanted', 'Storage', 'Monthly', 'New Resident'],
    date: 'March 21, 2026',
    condition: 'N/A',
  },
];
